module.exports = __webpack_public_path__ + "img/eject.ff41812a.svg";